const MenusFlag = {
  state: {
    isSubordinate:true,
  },
  mutations: {
    UPDATEIsSubordinate: (state, data) => {
      state.isSubordinate = data;
    },
  },
  actions: {
    updateIsSubordinate({ commit }, data) {
      commit("UPDATEIsSubordinate", data);
    },
  },
  getters: {
    isSubordinate: state => {
      return state.isSubordinate
    },
  }
};
export default MenusFlag;



// WEBPACK FOOTER //
// ./src/store/mutations/menuTab.js